import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import LeadGenFieldPickerModal from "./LeadGenFieldPickerModal";
import {formDataManager} from "../../hoc/formDataManager";
import {endLeadGenPickAction, submitLeadGenPickAction} from "./actions";

const mapStateToProps = (state) => {
    return {
        modalOpen: state.leadGenFieldPicker.picking
    }
};

const mapDispatchToProps = (dispatch) => ({
    onSaveData: (data) => dispatch(submitLeadGenPickAction(data.fieldNames)),
    handleClose: () => dispatch(endLeadGenPickAction())
});

const LeadGenFieldPickerModalConnected = connect(mapStateToProps, mapDispatchToProps);

const LeadGenFieldPickerModalFormDataManager = formDataManager({});

const LeadGenFieldPickerModalComposed = compose(
    LeadGenFieldPickerModalConnected,
    LeadGenFieldPickerModalFormDataManager
)(LeadGenFieldPickerModal);

export default LeadGenFieldPickerModalComposed;



// WEBPACK FOOTER //
// ./public/pages/LeadGenFieldPicker/LeadGenFieldPickerModalContainer.jsx